export class FaceImage {
  constructor(
    public imageAsBase64?: string,
    public contentType?: string,
    public photoPermission?: boolean
  ) {}
}
